import { render, staticRenderFns } from "./BigLogo.vue?vue&type=template&id=3ac9b56d&"
import script from "./BigLogo.vue?vue&type=script&lang=js&"
export * from "./BigLogo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports